const services = [
  {
    title: 'Carpet Cleaning & Repair',
    tagline: 'Deep-clean results that last.',
    desc: 'Hot water extraction removes allergens, stains, and embedded dirt. We also re-stretch, patch, and repair damaged carpet — saving you the cost of full replacement.',
    bullets: ['Hot water extraction', 'Pre-treatment spot removal', 'Re-stretching & patching', 'Pet odor neutralization'],
    icon: 'ri-brush-2-fill',
    img: 'https://public.readdy.ai/ai/img_res/d8b61ff4a68a58c7cfa8926d4a968f94.jpg',
  },
  {
    title: 'Luxury Vinyl Plank (LVP)',
    tagline: 'Waterproof. Durable. Beautiful.',
    desc: 'Premium LVP flooring installed with precision. Ideal for kitchens, bathrooms, and high-traffic areas. We carry top brands including Mohawk, Shaw, and MSI.',
    bullets: ['Expert measurement & fitting', 'Wide style selection', 'Residential & commercial', 'Financing available'],
    icon: 'ri-layout-grid-fill',
    img: 'https://readdy.ai/api/search-image?query=luxury%20vinyl%20plank%20flooring%20installation%20in%20modern%20open%20plan%20home%2C%20warm%20wood-look%20LVP%20planks%2C%20bright%20airy%20interior%2C%20clean%20minimal%20furniture%2C%20natural%20light%2C%20ultra-realistic%20photography%2C%20neutral%20warm%20tones%2C%20simple%20background&width=600&height=400&seq=svc-lvp-v3&orientation=landscape',
  },
  {
    title: 'Hardwood Floor Services',
    tagline: 'Restore the original beauty.',
    desc: 'Sanding, refinishing, deep cleaning, and new hardwood installation. We bring worn, scratched floors back to showroom condition.',
    bullets: ['Sanding & refinishing', 'Deep cleaning', 'New installation', 'Engineered wood'],
    icon: 'ri-tree-fill',
    img: 'https://readdy.ai/api/search-image?query=beautiful%20refinished%20hardwood%20floors%20in%20elegant%20home%20interior%2C%20rich%20warm%20oak%20wood%20grain%2C%20glossy%20finish%2C%20bright%20natural%20light%2C%20clean%20minimal%20room%2C%20ultra-realistic%20photography%2C%20warm%20amber%20tones%2C%20simple%20neutral%20background&width=600&height=400&seq=svc-hardwood-v3&orientation=landscape',
  },
  {
    title: 'Tile & Grout Cleaning',
    tagline: 'Looks brand new again.',
    desc: 'Professional-grade steam cleaning removes years of buildup from tile and grout. We also seal grout to protect against future staining.',
    bullets: ['High-pressure steam clean', 'Grout sealing', 'Stone & ceramic', 'Bathroom & kitchen'],
    icon: 'ri-grid-fill',
    img: 'https://readdy.ai/api/search-image?query=sparkling%20clean%20white%20tile%20and%20grout%20in%20modern%20bathroom%20or%20kitchen%2C%20professional%20cleaning%20result%2C%20bright%20white%20tiles%2C%20clean%20grout%20lines%2C%20natural%20light%2C%20ultra-realistic%20photography%2C%20clean%20minimal%20background%2C%20neutral%20tones&width=600&height=400&seq=svc-tile-v3&orientation=landscape',
  },
  {
    title: 'Pet Odor & Stain Removal',
    tagline: 'Eliminate odors at the source.',
    desc: 'Enzyme-based treatments that neutralize pet odors permanently — not just mask them. UV detection locates hidden contamination for complete elimination.',
    bullets: ['Enzyme-based treatment', 'UV detection', 'Safe for pets & kids', 'Deep sub-floor treatment'],
    icon: 'ri-heart-3-fill',
    img: 'https://readdy.ai/api/search-image?query=clean%20fresh%20carpet%20in%20bright%20modern%20living%20room%20with%20happy%20family%20pet%2C%20pristine%20light%20beige%20carpet%2C%20warm%20natural%20light%2C%20cozy%20home%20interior%2C%20ultra-realistic%20photography%2C%20warm%20neutral%20tones%2C%20simple%20clean%20background&width=600&height=400&seq=svc-pet-v3&orientation=landscape',
  },
  {
    title: 'Upholstery Cleaning',
    tagline: 'Save thousands vs. replacement.',
    desc: 'Restore your furniture to like-new condition. Our specialists clean fabric and leather upholstery, removing stains, odors, and allergens safely.',
    bullets: ['Fabric & leather care', 'Stain extraction', 'Deodorizing treatment', 'Sofa, chairs & more'],
    icon: 'ri-sofa-fill',
    img: 'https://readdy.ai/api/search-image?query=clean%20freshly%20cleaned%20light%20gray%20fabric%20sofa%20in%20bright%20modern%20living%20room%2C%20professional%20upholstery%20cleaning%20result%2C%20natural%20light%2C%20minimal%20interior%2C%20ultra-realistic%20photography%2C%20warm%20neutral%20tones%2C%20simple%20clean%20background&width=600&height=400&seq=svc-upholstery-v3&orientation=landscape',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">

        {/* Section header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <p className="text-amber-600 text-[11px] font-bold tracking-[0.25em] uppercase mb-3">What We Do</p>
            <h2 className="font-serif text-4xl md:text-5xl text-stone-900 leading-tight">
              Flooring &amp; Carpet<br className="hidden md:block" /> Services
            </h2>
          </div>
          <div className="max-w-sm">
            <p className="text-stone-500 text-base leading-relaxed">
              Every service backed by our 100% satisfaction guarantee. If you&apos;re not happy, we return and re-service free.
            </p>
          </div>
        </div>

        {/* Thin rule */}
        <div className="w-full h-px bg-stone-100 mb-16"></div>

        {/* Services grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-stone-100">
          {services.map((svc) => (
            <article
              key={svc.title}
              className="group bg-white p-8 hover:bg-stone-50/80 transition-colors duration-300 cursor-default"
            >
              {/* Image */}
              <div className="relative w-full h-48 rounded-xl overflow-hidden mb-6">
                <img
                  src={svc.img}
                  alt={`${svc.title} — Carpet & Flooring Transformers`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent"></div>
              </div>

              {/* Icon + title */}
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center bg-amber-50 rounded-lg flex-shrink-0 mt-0.5">
                  <i className={`${svc.icon} text-amber-600 text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-stone-900 font-bold text-base leading-snug">{svc.title}</h3>
                  <p className="text-amber-600 text-xs font-semibold mt-0.5">{svc.tagline}</p>
                </div>
              </div>

              <p className="text-stone-500 text-sm leading-relaxed mb-5">{svc.desc}</p>

              <ul className="space-y-1.5 mb-6">
                {svc.bullets.map((b) => (
                  <li key={b} className="flex items-center gap-2 text-[13px] text-stone-600">
                    <div className="w-3 h-3 flex items-center justify-center text-amber-500 flex-shrink-0">
                      <i className="ri-check-line font-bold"></i>
                    </div>
                    {b}
                  </li>
                ))}
              </ul>

              <a
                href="#estimate-form"
                className="inline-flex items-center gap-1.5 text-stone-800 text-[13px] font-bold group-hover:text-amber-700 transition-colors cursor-pointer border-b border-stone-200 group-hover:border-amber-400 pb-0.5"
              >
                Get a Quote
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </div>
              </a>
            </article>
          ))}
        </div>

        {/* Post-services CTA */}
        <div className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:7702361255"
            className="inline-flex items-center gap-2.5 bg-stone-900 hover:bg-amber-600 text-white font-bold text-sm px-9 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            Call 770.236.1255 — Free Consultation
          </a>
          <a
            href="#estimate-form"
            className="inline-flex items-center gap-2 border border-stone-300 hover:border-stone-900 text-stone-700 hover:text-stone-900 font-semibold text-sm px-9 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Request Estimate Online
          </a>
        </div>
      </div>
    </section>
  );
}
